export function strikethroughMarkSpec() {
    return {
        strikethrough: {
            parseDOM: [
                { tag: "s" },
                { tag: "del" },
                { tag: "strike" },
                {
                    style: "text-decoration",
                    getAttrs: (value) => (value === "line-through" ? {} : false),
                },
            ],
            toDOM: () => ["s", {}, 0],
        },
    };
}
